// eslint-disable-next-line import/prefer-default-export
export const APPLICANT_EN = {
  // common
  Cancel: 'Cancel',
  Accept: 'Accept',
  Send: 'Send',
  ImSure: "I'm sure",
  Applicant: 'Applicant',
  AddedBy1: 'Added by',
  AddedBy2: 'on: ',
  Of: 'of ',

  // menuPop
  GeneralMenu: 'General',
  CommentsMenu: 'Comments',
  ScoresMenu: 'Scores',
  TransferMenu: 'Transfer',
  InterviewMenu: 'Interview',
  ActivityMenu: 'Activity',
  BackgroundMenu: 'Background',
  testingMenu: 'Test',

  // Sub menu pop
  SubMenuHistory: 'History',
  SubMenuApplications: 'Applications',

  // Table
  Vacancy: 'Vacancy',
  Application: 'Application',
  Status: 'Status',
  Prom: 'Score',
  noName: 'Name not retrieved',

  // pdfViewer
  InvalidFile: 'The file is either invalid or damaged',
  NoFile: 'There is no file but you could upload a new CV',
  ServerError: 'The server does not respond',
  ApiError: 'There was an API server error',
  NoFileFound: 'No file was found',
  GeneralError: 'Error, something went wrong.',
  LoadingPDF: 'Loading PDF',
  FailureMessage: 'We have tried to convert the CV but we did not succeed',
  uploadFile: 'Drop files here to upload',
  onlyPDF: 'Only PDF file',
  FailureMessageFromBase: 'We could not convert the file, please try from the vacancy view.',
  WaitMessage: "Wait, we are converting the CV, don't leave",
  tooltipDownload: 'Download',
  // Tabs
  FreeCv: 'FREE CV',
  Testing: 'TESTING',
  CvWithBiases: 'CV WITH BIASES',
  CvWithoutBiases: 'CV WITHOUT BIASES',
  // testing
  PercentageCorrect: 'correct',
  Competence: 'Competence',
  ApplicantsAnswer: "Applicant's answer",
  AvailableOptions: 'Available options: ',
  Correct: 'Correct',
  Incorrect: 'Incorrect',
  DidNotAnwer: 'Did not answer',
  PersonalQuestionnaire: 'Personal Questionnaire',
  ResultQuestions: 'Result',

  // gmailIntegration
  EmailHeader: 'Customize email',
  EmailMessage: 'We will send the email with Gmail',
  Subject: 'Subject:',
  Emails: 'Emails',
  placeholderTextArea: 'Type your message',

  // unlinked gmail
  UnlinkedHeader: 'You have not linked your Gmail account',
  UnlinkedMessage1: 'You can now link your Gmail account directly from here',
  UnlinkedMessage2: "Why don't you try it?",
  LinkAccount: 'Link account',
  NotNow: 'Not now',

  // deleteCandidate
  DeleteHeader: 'Delete candidate',
  DeleteMessage1: 'Are you sure you want to delete this candidate?',
  DeleteMessage2: 'Careful! This action cannot be reverted',

  // liteView
  LiteHeader: 'Share candidate (Lite View)',
  LiteMessage:
    "Share a candidate with people both inside and outside your company so they can see the candidate's info",
  Setup: 'Setup',
  ExpirationDate: 'Expiration date',
  Never: 'Never expires',
  AnyoneCanSee: 'Can everyone see it?',
  Yes: 'Yes',
  No: 'No',
  SelectUsers: 'SelectUsers',
  Link: 'Link to share',
  CopyLink: 'Copy link',
  CopiedLink: 'Copied link',
  Saved: 'Saved',

  // scheduleEvent
  AddEvent: 'New event',
  DateAssignment: 'Date Assignment',
  placeholderTitle: 'Title',
  placeholderDescription: 'Description',
  InitialDate: 'Start',
  FinalDate: 'Final',
  AskMeet: 'Request Meet',
  NotifyGuests: 'Notify guests',
  placeholderEmail: 'Guest email',
  EventTitle: 'Event title',
  EventDate: 'Event date',
  Time: 'Time',
  TextTime: 'All day',
  InviteMembers: 'Invited Members',
  SaveEvent: 'Save',
  AddDescription: 'Add description',

  // generalStep
  AppliedOn: 'Applied on:',
  AppliedFrom: 'Applied from:',
  Email: 'Email:',
  Description: 'Description:',
  ApplicantDidNotComment: 'Applicant did not comment',
  SingleActions: 'Single actions',
  ExtraFiles: 'Extra files',
  AppliccantHistory: 'Applicant record',
  ToggleUpHistory: 'Show applicant record',
  ToggleDownHistory: 'Hide applicant record',
  moveOtherColumn: 'Move to another column',
  select: 'Select',
  move: 'Move',
  EmailSecondary: 'Email Secondary',
  PhoneSecondary: 'Phone Secondary',
  // commentsStep
  Question: 'What do you think?',
  TypeHere: 'Type here your comment',
  Post: 'Post',
  Edit: 'Edit',
  EditComment: 'Edit comment',
  NoComments: 'No comments yet, be the first one',
  // scoresStep
  Scores: 'Scores',
  Score: 'Score',
  AverageScore: 'Average score',
  OtherScores: 'Other scores',
  NoScores: 'No scores yet, be the first one',
  CannotScore: 'It is not possible to score this applicant from here.',
  AlreadyScored: 'You have already assigned a score to this applicant',
  UpdateScore: 'Update score',
  tooltipAddCriterion: 'Add score criterion',
  placeholderNameCriterion: 'Criterion name',
  CriteriaMessage1: 'Add criteria that will be evaluated',
  CriteriaMessage2: 'will be applied in the whole vacancy',
  AddCriteriaConfirmation: 'Once added this criterion you will not be able to modify it, do you want to continue?',
  // transferStep
  Transfer: 'Transfer',
  Invite: 'Invite',
  placeholderSearch: 'Search vacancy',
  Vacancies: 'Vacancies',
  PostDate: 'Post date',
  Actions: 'Actions',
  tooltipTransfer1: 'The applicant will be transferred and notified',
  tooltipInvite1: 'A link to the vacancy will be sent to the applicant',
  tooltipTransfer2: 'Transfer applicant',
  tooltipInvite2: 'Invite applicant',
  // activityStep
  ScoreRegistered: 'Score registered',
  ScoreUpdated: 'Score updated',
  CommentRegistered: 'Comment registered',
  CommentUpdated: 'Comment updated',
  copyEmail: 'Copied email',
  deleteSave: 'Removed from saved',
  addSaved: 'Saved',
  addFiled: 'File added',
  sendOutlook: 'Sended email by Outlook',
  sendGmail: 'Sended email by Gmail',
  transferred: 'Transferred candidate to another vacancy',
  invited: 'Invited candidate to another vacancy',
  sendTest: 'Sended test',
  updateTest: 'Updated test',
  sendInvitation: 'Meet invitation sent',
  NoRegisters: 'No registers yet',
  // background
  Text1: "¿Do you need to know the applicant's background?",
  Text2: "For this action, we need the applicant's CURP",
  Text3: 'This applicant has not been investigated',
  Text4: '*Only available in México.*',
  CurpCandidate: "Applicant's CURP",
  CandidateAgrees: 'The applicant agrees with the investigation',
  AllFields: 'Complete all fields',
  CheckForFree: 'Check background for free',
  Consulting: 'Consulting, please wait',

  // tooltips
  tooltipSchedule: 'Schedule event',
  tooltipSave: 'Save as distinguished applicant',
  tooltipDontSave: 'Do not save anymore',
  tooltipSendEmail: 'Send email',
  tooltipCopyEmail: 'Copy email',
  tooltipSendWhats: 'Send WathsApp',
  tooltipShare: 'Share applicant',
  tooltipReject: 'Reject applicant',
  tooltipMove: 'Move applicant',
  tooltipAddFile: 'Add file',

  // Notifications
  MissingApproval: 'Applicant approval is missing',
  CurpInvalid: 'Invalid CURP',
  CriterionAlreadyAdded: 'Criterion already added',
  CheckAllData: 'Please check all data',
  FillAllFields: 'Please fill all fields',
  MessageSent: 'Message sent',
  MessageSent2: 'Your message has been sent',
  MessageFailed: 'Message failed',
  MessageNotSent: 'Message not sent',
  EmailCopied: 'Email copied',
  ChangeMade: 'Change made',
  SimpleServerError: 'Server error',
  booleanQuestion: 'Closed question',
  multipleOptions: 'Multiple options',
  rangesQuestion: 'Question by ranges',
  missingType: 'Missing type of question',
  automaticQuestion: 'Automatic question',
  average: 'Average',
  free: 'Free answer',

  // Move columns
  NewName: 'New name',
  Unnamed: 'Unnamed',
  PersonalFilter1: 'Personal filter 1',
  PersonalFilter2: 'Personal filter 2',
  RejectedWillBeNotified: 'Applicant will be notified by email',
  NewCandidates: 'New applicants',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  npsName: 'NPS name',
  npsDate: 'Date',
  npsIgnored: 'Ignored',
  npsRead: 'Read',
  npsAnswered: 'Answered',
  npsPending: 'Pending',

  // categories
  Administration: 'Administration',
  Banking: 'Banking',
  Law: 'Law',
  Development: 'Web development / IT',
  Design: 'Design',
  Edtech: 'Edtech',
  Finances: 'Finances',
  Fintech: 'Fintech',
  Healathtech: 'Healthtech',
  Humanities: 'Humanities',
  CreativeIndustries: 'Creative industries',
  Engineering: 'Engineering',
  Insurtech: 'Insurtech',
  Legal: 'Legal',
  Logistics: 'Logistics',
  Management: 'Management',
  DigitalMarketing: 'Digital marketing',
  Fashion: 'Fashion',
  OngSocial: "ONG's, social, operations",
  Psychology: 'Psychology',
  Proptech: 'Proptech',
  HumanResources: 'Human resources',
  Health: 'Health',
  Insurances: 'Insurances',
  Sells: 'Sells',
  Other: 'Others',
  extension: 'Extensions',

  // InterView
  wishes: 'Wishes',
  interests: 'Personal interests',
  opportunity: 'Area opportunity',
  selected: 'Select interests',
  search: 'What position are you looking for?',
  IndustriesInterest: 'Industries of interest',
  idiomas: 'Languages',
  selectLanguages: 'Select Languages',
  minimumSalary: 'Minimum salary',
  DesiredLocation: 'Desired location',
  availability: 'Do you have availability for remote work?',
  relocationAvailability: 'Do you have relocation availability?',
  languageLevel: 'Language level',
  interesesProfesionales: 'Intereses profesionales',
  whatWishes: 'What are the wishes of the candidate?',
  notes: 'Notes',
  save: 'Save',
  motherTongue: 'mother tongue',
  beginner: 'Beginner',
  middle: 'Middle',
};
